import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/sonner';
import { ROUTE_PATHS } from '@/lib/index';
import Home from '@/pages/Home';
import Learn from '@/pages/Learn';
import Review from '@/pages/Review';
import Phonics from '@/pages/Phonics';
import ProgressPage from '@/pages/Progress';
import Parent from '@/pages/Parent';
import Rewards from '@/pages/Rewards';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <MotionConfig reducedMotion="user">
        <HashRouter>
          <Routes>
            <Route path={ROUTE_PATHS.HOME} element={<Home />} />
            <Route path={ROUTE_PATHS.LEARN} element={<Learn />} />
            <Route path={ROUTE_PATHS.REVIEW} element={<Review />} />
            <Route path={ROUTE_PATHS.PHONICS} element={<Phonics />} />
            <Route path={ROUTE_PATHS.PROGRESS} element={<ProgressPage />} />
            <Route path={ROUTE_PATHS.PARENT} element={<Parent />} />
            <Route path={ROUTE_PATHS.REWARDS} element={<Rewards />} />
            <Route path="*" element={<Navigate to={ROUTE_PATHS.HOME} replace />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </HashRouter>
      </MotionConfig>
    </QueryClientProvider>
  );
}